import React, { useEffect, useState } from "react";
import MenuIcon from "@material-ui/icons/Menu";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import CloseIcon from "@material-ui/icons/Close";
import { useDispatch, useSelector } from "react-redux";
import { push } from "connected-react-router";
import "../../assets/css/drawer.css";
import { fechAuthState, fechCurrentUser } from "../../reducks/users/operations";
import { getCurrentUser, getUserId } from "../../reducks/users/selectors";
import GuestImage from "../../assets/img/src/no-profile.png";

const useStyles = makeStyles({
  listStyle: {
    width: "auto",
    textAlign: "right",
  },
  iconColor: {
    color: "#656565",
  },
});

const OrganizerDrawer = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const selector = useSelector((state) => state);
  const uid = getUserId(selector);
  const currentUser = getCurrentUser(selector);

  const [open, setOpen] = useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const list = () => (
    <div className={classes.listStyle} role="presentation">
      <List>
        <div
          className="drawer-cancel-btn hover1"
          onClick={() => {
            handleDrawerClose();
          }}
        >
          <CloseIcon style={{ fontSize: 25 }} />
        </div>

        <div className="center">
          <div className="spacer-box--ss" />
          {typeof currentUser.avatar !== "undefined" ? (
            <img className="avatar-trim" src={currentUser.avatar} alt="アバター画像" width="50" />
          ) : (
            <img className="avatar-trim" src={GuestImage} alt="アバター画像" width="50" />
          )}
          <div className="user-name-text yu-gothic">{currentUser.username}</div>
        </div>
        <Divider />

        {props.isBoothEditing && (
          <>
            <div
              className="drawer-list--organizer text-primary bold hover1"
              onClick={() => dispatch(push("/booth/edit/"))}
            >
              ブース作成
            </div>
            <Divider />
          </>
        )}
        {props.isOpusEditing && (
          <>
            <div
              className="drawer-list--organizer text-primary bold hover1"
              onClick={() => dispatch(push("/opus/edit/"))}
            >
              作品登録
            </div>
            <Divider />
          </>
        )}

        <div className="drawer-list--organizer hover1 drawer-menu-basic" onClick={() => dispatch(push("/Account"))}>
          アカウント管理
        </div>
        <Divider />
        <div className="drawer-list--organizer hover1 drawer-menu-basic">ヘルプ(準備中)</div>
        <Divider />

        <div className="drawer-spacer"></div>
        <Divider />
        <div
          className="drawer-list--organizer hover1 drawer-menu-basic"
          onClick={() => dispatch(push("/organizer/" + uid))}
        >
          会員ページTOPへ
        </div>
        <Divider />
        <div className="drawer-list--organizer hover1 drawer-menu-basic" onClick={() => dispatch(push("/boothlist"))}>
          メインページへ
        </div>
        <Divider />
      </List>
    </div>
  );

  useEffect(() => {
    dispatch(fechAuthState());
    if (uid !== "") {
      dispatch(fechCurrentUser(uid));
    }
    // eslint-disable-next-line
  }, [uid]);

  return (
    <div>
      <div
        className="hover1 drawer-menu-btn"
        onClick={() => {
          handleDrawerOpen();
        }}
      >
        <MenuIcon className={classes.iconColor} style={{ fontSize: props.fontSize }} />
      </div>
      <Drawer anchor="right" open={open}>
        {list()}
      </Drawer>
    </div>
  );
};
export default OrganizerDrawer;
